import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "../context/ThemeContext";

const ChallengeCard = ({ title, cover, amount, deadline, url }) => {
  const { isDarkMode } = useTheme();
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleCardClick = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="overflow-hidden p-[1px] rounded-[30px] group">
      <motion.div
        className={`w-[285px] overflow-hidden rounded-[30px] border ${
          isDarkMode
            ? "bg-[#000000] border-[#333] group-hover:border-[#333]"
            : "bg-white border-gray-200 group-hover:border-gray-200"
        } cursor-pointer relative`}
        whileHover={{ scale: 1.02 }}
        transition={{ duration: 0.2 }}
        onClick={handleCardClick}
      >
        <div className="relative h-[180px] overflow-hidden">
          {/* Loading placeholder */}
          <AnimatePresence>
            {!imageLoaded && (
              <motion.div
                initial={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className={`absolute inset-0 ${
                  isDarkMode ? "bg-[#1A1A1A]" : "bg-gray-200"
                } animate-pulse`}
              />
            )}
          </AnimatePresence>

          {/* Actual image */}
          <motion.img
            src={cover}
            alt={title}
            className={`w-full h-full object-cover ${
              !imageLoaded ? "opacity-0" : "opacity-100"
            }`}
            initial={{ opacity: 0 }}
            animate={{ opacity: imageLoaded ? 1 : 0 }}
            transition={{ duration: 0.3 }}
            onLoad={() => setImageLoaded(true)}
            loading="lazy"
          />
        </div>

        <div
          className={`p-6 rounded-b-[30px] ${
            isDarkMode ? "bg-[#000000]" : "bg-white"
          }`}
        >
          <h3
            className={`text-[16px] font-bold mb-6 text-left font-lexend ${
              isDarkMode ? "text-[#fff]" : "text-black"
            }`}
          >
            {title}
          </h3>

          <p
            className={`text-[14px] mb-2 text-left font-light font-lexend ${
              isDarkMode ? "text-[#fff]" : "text-gray-600"
            }`}
          >
            {deadline}
          </p>

          <p
            className={`text-[14px] font-lexend font-light mb-6 text-left ${
              isDarkMode ? "text-[#fff]" : "text-black"
            }`}
          >
            {amount}
          </p>

          {/* Single line that extends to edges */}
          <div className="-mx-6">
            <div
              className={`border-t ${
                isDarkMode ? "border-[#333]" : "border-gray-200"
              }`}
            />
            <div className="flex items-center gap-2 pt-6 px-6">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.3333 10.0833V17.4167C18.3333 19.9439 16.2773 22 13.75 22H4.58333C2.05608 22 0 19.9439 0 17.4167V8.25C0 5.72275 2.05608 3.66667 4.58333 3.66667H11.9167C12.4227 3.66667 12.8333 4.07733 12.8333 4.58333C12.8333 5.08933 12.4227 5.5 11.9167 5.5H4.58333C3.06717 5.5 1.83333 6.73383 1.83333 8.25V17.4167C1.83333 18.9328 3.06717 20.1667 4.58333 20.1667H13.75C15.2662 20.1667 16.5 18.9328 16.5 17.4167V10.0833C16.5 9.57733 16.9107 9.16667 17.4167 9.16667C17.9227 9.16667 18.3333 9.57733 18.3333 10.0833ZM19.25 0H12.8333C12.3273 0 11.9167 0.410667 11.9167 0.916667C11.9167 1.42267 12.3273 1.83333 12.8333 1.83333H18.8705L7.60192 13.1019C7.2435 13.4603 7.2435 14.0397 7.60192 14.3981C7.78067 14.5768 8.01533 14.6667 8.25 14.6667C8.48467 14.6667 8.71933 14.5768 8.89808 14.3981L20.1667 3.1295V9.16667C20.1667 9.67267 20.5773 10.0833 21.0833 10.0833C21.5893 10.0833 22 9.67267 22 9.16667V2.75C22 1.23383 20.7662 0 19.25 0Z"
                  fill= {isDarkMode ? "#fff" :"#000"}
                />
              </svg>

              <span
                className={`text-[14px] font-lexend font-light ${
                  isDarkMode ? "text-[#fff]" : "text-black"
                }`}
              >
                Lets explore
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ChallengeCard;
